<script lang="ts">
  import type { Snippet } from "svelte"
  import type { HTMLAttributes } from "svelte/elements"
  import { fly } from "../transition"

  let {
    key,
    backward = false,
    delay,
    duration,
    offset = "150%",
    children,
    ...props
  }: {
    key?: unknown
    backward?: boolean
    delay?: number
    duration?: number
    offset?: string
    children?: Snippet
  } & HTMLAttributes<HTMLDivElement> = $props()

  let [inOffsetDir, outOffsetDir] = $derived(backward ? ["-", ""] : ["", "-"])
</script>

<div {...props} class={`casing ${props.class ?? ""}`}>
  <div class="placeholder">
    {@render children?.()}
  </div>
  {#key key}
    <div
      class="reel"
      in:fly|local={{ delay, duration, y: `${inOffsetDir}${offset}` }}
      out:fly|local={{ delay, duration, y: `${outOffsetDir}${offset}` }}
    >
      {@render children?.()}
    </div>
  {/key}
</div>

<style lang="postcss">
  .casing {
    @apply relative w-full;
  }

  .placeholder {
    @apply invisible;
  }

  .reel {
    @apply absolute left-1/2 top-0 w-full -translate-x-1/2;
  }
</style>
